



















import Vue from "vue";
import GrapherField from "./GrapherField.vue";
import GrapherDots from "./GrapherDots.vue";
import GrapherTool from "./GrapherTool.vue";
import svgPanZoom from "svg-pan-zoom";
import BaseTool from "@/tools/BaseTool";
import { Mutations } from "@/store/mutations";

/**
 * Holds the components for rendering the field, dots, tools, etc.
 */
export default Vue.extend({
  name: "Grapher",
  components: {
    GrapherField,
    GrapherDots,
    GrapherTool,
  },
  mounted() {
    const svgPanZoomInstance = svgPanZoom(".grapher--svg", {
      viewportSelector: ".grapher--wrapper",
      panEnabled: true,
      zoomEnabled: true,
      controlIconsEnabled: true,
      dblClickZoomEnabled: false,
    });
    this.$store.commit(Mutations.SET_GRAPHER_SVG_PAN_ZOOM, svgPanZoomInstance);

    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize(): void {
      this.$store.state.grapherSvgPanZoom.resize();
    },
    onMouseDown(event: MouseEvent): void {
      const toolSelected: BaseTool = this.$store.state.toolSelected;
      toolSelected.onMouseDown(event);
    },
    onMouseUp(event: MouseEvent): void {
      const toolSelected: BaseTool = this.$store.state.toolSelected;
      toolSelected.onMouseUp(event);
    },
    onMouseMove(event: MouseEvent): void {
      const toolSelected: BaseTool = this.$store.state.toolSelected;
      toolSelected.onMouseMove(event);
    },
  },
});
